import PropTypes from 'prop-types';
import styled from 'styled-components';
import { reduxPropTypes } from '@figure/frontlib-onboarding-redux';
import { Button, Error, Typography } from '@figure/frontlib-gui';
import { PdfDocument } from 'shared/components';
import { Disclosure } from 'shared/constants';
import { PageHeader } from 'shared/components/Typography';

const StyledContainer = styled.div`
  margin-bottom: 30px;
`;

const Legal = styled(Typography.SmallBodyBold)`
  margin: 16px 0 32px;
`;

const AdditionalLegal = styled(Typography.SmallBody)`
  margin: 16px 0 32px;
`;

const SignDisclosure = ({ file, handleSubmit, disclosure, serverError, children, header }) => {
  if (!disclosure || !disclosure.document || !disclosure.document.type) return null;
  let legal;
  let button = 'I accept';
  let btn_dt_id = 'accept';
  let additionalLegal;

  // TODO: Will we have all of these documents? Any additional ones?
  switch (disclosure.document.type) {
    case 'APPLICATION_SUMMARY':
      button = 'Submit Application';
      btn_dt_id = 'submit-application';

      break;
    case 'CREDITDISCLOSURE':
      legal = 'By pressing “Next”, I confirm that I have read and understand the above Documents.';
      button = 'Next';
      btn_dt_id = 'next';
      break;
    // TODO: Look into this
    case 'STATEMENTOFLOAN':
      legal =
        'By pressing "I accept," I agree to be bound by the terms of the above document and confirm that a broker was not ' +
        'used in conjunction with this loan.';
      break;
    case Disclosure.PL_AGREEMENT:
      legal = (
        <>
          By pressing "I accept," I agree to be bound by the terms of the above document.
          <br />
          <br />
          Please be advised that your loan could fund without any further action from you upon
          pressing “I accept” if no further review is required. If you have any questions about your
          loan or are not certain you want to receive funds, contact customer support as soon as
          possible.
        </>
      );
      break;
    default:
      legal = 'By pressing "I accept," I agree to be bound by the terms of the above document.';
      break;
  }

  switch (disclosure.type) {
    case Disclosure.CLOSING_DISCLOSURE:
      additionalLegal = `You may also access and review these documents from your Dashboard and return to sign them after you've reviewed them.`;
      break;
    default:
      additionalLegal = '';
      break;
  }

  return (
    <StyledContainer>
      <PageHeader>{header || 'Review document'}</PageHeader>
      {file && <PdfDocument file={file} />}

      {children}
      <Legal>{legal}</Legal>

      <Error display="block">{serverError}</Error>

      <Button
        onClick={() => handleSubmit(disclosure)}
        primary
        large
        center
        data-test-id={btn_dt_id}
      >
        {button}
      </Button>

      {additionalLegal && <AdditionalLegal>{additionalLegal}</AdditionalLegal>}
    </StyledContainer>
  );
};

SignDisclosure.propTypes = {
  disclosure: reduxPropTypes.disclosure.isRequired,
  file: PropTypes.object,
  handleSubmit: PropTypes.func.isRequired,
  serverError: PropTypes.string.isRequired,
  children: PropTypes.node,
  header: PropTypes.string,
};

SignDisclosure.defaultProps = {
  file: undefined,
  children: null,
  header: '',
};

export default SignDisclosure;
